import Swiper from 'swiper/bundle';
import videojs from 'video.js';

$(document).ready(function () {
    // Copy link post
    $('#copyButton').click(function (e) {
        e.preventDefault();
        // Create a temporary input element
        const tempInput = $('<input>');
        tempInput.val(window.location.href);
        $('body').append(tempInput);
        // Select the input's content and copy it to the clipboard
        tempInput.select();
        document.execCommand('copy');
        // Remove the temporary input element
        tempInput.remove();
        $('#doneButton').fadeTo(500, 1,);
        setTimeout(function () {
            $('#doneButton').fadeOut(1300);
        }, 2000); // Reset the button text after 2 seconds
    });

    // Desktop progress bar
    const progressBar = $('#progress-bar');
    const progressNum = $('.progress-num');
    const sectionHeight = $('.section-single-post-aktuelles').outerHeight();
    const windowHeight = $(window).outerHeight();
    $(window).on('scroll', function () {
        const scrollTop = $(window).scrollTop();
        const scrollPercentage = (scrollTop / (sectionHeight - windowHeight)) * 100;
        const screenWidth = $(window).width();
        const progressBarMobile = $('#progress-bar-mobile');
        const progressBarContainerMobile = $('.progress-container-mobile');

        if (screenWidth >= 768) {
            if (scrollPercentage >= 10 && scrollPercentage <= 100) {
                progressBar.show();
                progressNum.text(`${Math.round(scrollPercentage)}%`);
                const progressBarTop = (scrollPercentage * (windowHeight * 0.8)) / 100;
                progressBar.css('top', progressBarTop + 'px');
            } else {
                progressBar.hide();
            }
        } else {
            if(scrollPercentage >= 10) {
                progressBarContainerMobile.fadeIn(100);
                progressBarMobile.css('width', scrollPercentage + '%');
            } else {
                progressBarContainerMobile.fadeOut(100);
            }
        }

        //when header scroll to bottom progressbar fixed in mobile
        let header = $('header');
        if (header.hasClass('show-fixed')) {
            progressBarContainerMobile.addClass('fixed');
        } else {
            progressBarContainerMobile.removeClass('fixed');
        }
    });

    // initializing video
    $('.section-single-post-aktuelles .content .wp-video-shortcode').addClass('video-js vjs-theme-revocit');

    let videoElements = document.querySelectorAll('video');

    videoElements.forEach((videoElement) => {
        videojs(videoElement);
    });

});


if ($(".aktuelles-resultate-slider.swiper-container").length > 0) {
    const single_aktuelles_resultate_swiper = new Swiper(".aktuelles-resultate-slider.swiper-container", {
        slidesPerView: 'auto',
        loop: false,
        navigation: {
            nextEl: ".swiper-button-next.resultate-swiper-button",
            prevEl: ".swiper-button-prev.resultate-swiper-button",
        },
    });
}